import { MediaCollection, PaginatedResponse } from '@arpeggi/shared'
import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query'
import { getNextPage, getPreviousPage } from '../../../__legacy__/queries/common'
import { getMediaCollections } from '../../api/functions'
import { GetMediaCollectionParams } from '../types'

export const useMediaCollections = ({
  params,
  options
}: {
  params: GetMediaCollectionParams
  options?: UseInfiniteQueryOptions<PaginatedResponse<MediaCollection>>
}) => {
  return useInfiniteQuery(
    ['media-collections', params],
    ({ pageParam = params?.page || 1 }) => getMediaCollections({ ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage),
      ...options
    }
  )
}
